"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
function handleAddBetslipBet(state) {
    var newBetslipBet = utils_1.createBetslipBet();
    var nextBetslipBets = state.betslipBets.set(newBetslipBet.id, newBetslipBet);
    return state.set('betslipBets', nextBetslipBets);
}
exports.default = handleAddBetslipBet;
//# sourceMappingURL=handleAddBetslipBet.js.map